import { GoogleTagSlot } from '../../types/ads/Ad.interface'

const googletagSlotsToIds = (divIdsOrSlots: string[] | GoogleTagSlot[] | (string | GoogleTagSlot)[]) =>
    divIdsOrSlots.map(slotOrDivId =>
        typeof slotOrDivId === 'string' ? slotOrDivId : slotOrDivId?.getSlotElementId?.()
    )

export default googletagSlotsToIds
